<template>
  <div class="outContainer" id="outContainer" :style="{ height: boxHeight, width: boxWidth }">
    <div class="ScreenAdapter" :style="style">
      <slot />
    </div>
  </div>
</template>
<script>

export default {
  name: "ScreenAdapter",
  //参数注入
  props: {
    width: {
      type: String,
      default: "1920",
    },
    height: {
      type: String,
      default: "1080",
    },
  },
  data () {
    return {
      boxWidth: this.width,
      boxHeight: this.height,
      style: {
        width: this.width + "px",
        height: "auto",
        transform: "scale(1) translate(-50%, -50%)",
      },
    };
  },
  mounted () {
    let that = this
    this.setScale(true);
    window.onresize = this.Debounce(this.setScale, 0, that);
  },
  destroyed () {
    let that = this
    window.removeEventListener("resize", this.Debounce(this.setScale, 0, that));
  },
  methods: {
    Debounce: (fn, t, that) => {
      that.$emit("Fresize")
      const delay = t || 500;
      let timer;
      return function () {
        const args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        const context = this;
        timer = setTimeout(() => {
          timer = null;
          fn.apply(context, args);
        }, delay);
      };
    },
    // 获取放大缩小比例
    getScale () {
      //容器高度
      this.boxWidth =
        this.width == "1500"
          ? document.body.clientWidth -
          this.$(".el-scrollbar__view").width() +
          "px"
          : document.body.clientWidth + "px";
      this.boxHeight = document.body.clientHeight + "px";

      let w;
      w =
        this.width == "1500"
          ? ((document.body.clientWidth) -
            this.$(".el-scrollbar__view").width()) /
          this.width
          : (document.body.clientWidth) / this.width;

      return w;
    },
    // 设置比例
    setScale () {
      this.style.transform = "scale(" + this.getScale() + ") translate(0, 0)";

      //解决改变窗口大小时，意外出现滚动条问题
      this.$nextTick(() => {
        this.style.transform = "scale(" + this.getScale() + ") translate(0, 0)";
      });
      var scale = this.getScale()
      this.$emit("scrollVal", [this.style, scale])
    },
  },
};
</script>
<style lang="less" >
.ScreenAdapter {
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    transform-origin: 0 0;
    position: absolute;
    left: 0;
    right: -17px;
    // transition: 0.3s;
    background: #fff;
}
.ScreenAdapter::-webkit-scrollbar {
    display: none; /* Chrome Safari */
}
.outContainer::-webkit-scrollbar {
    display: none; /* Chrome Safari */
}
.outContainer {
    overflow-y: scroll;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    position: relative;
}
.el-scrollbar__view {
    overflow: hidden;
}
</style>
